export default [
  {
    path: "/peternakan",
    component: () => import("@/pages/peternakan/peternakan-list.vue"),
    meta: {
      requiredLevel: ["admin", "peternakan"],
    },
  },
  {
    path: "/peternakan/import",
    component: () => import("@/pages/peternakan/peternakan-import.vue"),
    meta: {
      requiredLevel: ["admin", "peternakan"],
    },
  },
];
